/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const storyFilterNodes = Array.from(document.querySelectorAll('.story-filters'));
if (storyFilterNodes.length) {
    import(/* webpackChunkName: "StoryFilters" */ './components/StoryFilters').then(({ default: StoryFilters }) => {
        storyFilterNodes.forEach((node) => render(<StoryFilters {...parseDataToProps(node.dataset)} />, node));
    });
}
